import React from "react";

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

export const MenuSmartIcon = React.memo(
  ({ width = 24, height = 18, color = "#323232" }: Props) => {
    return (
      <svg
        width={`${width}`}
        height={`${height}`}
        viewBox="0 0 24 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.272 9.072H18.588V6.552H17.556V5.952H20.292V6.552H19.26V9.072H19.272ZM15.96 7.932C16.284 7.944 16.32 7.992 16.32 8.544V9.072H17.004V8.16C17.004 7.896 16.92 7.752 16.728 7.644C16.968 7.524 17.016 7.428 17.016 7.128V6.552C17.016 6.084 16.836 5.952 16.248 5.952H14.292V9.072H15V7.932H15.96ZM16.308 6.864V7.044C16.308 7.296 16.26 7.32 15.864 7.32H15V6.54H15.876C16.248 6.54 16.308 6.576 16.308 6.852V6.864ZM13.08 9.072H13.812L12.768 5.952H11.844L10.788 9.072H11.508L11.724 8.352H12.84L13.08 9.072ZM12.276 6.468L12.696 7.74H11.892L12.276 6.468ZM8.352 9.072H9.06L9.624 6.936V9.072H10.284V5.952H9.228L8.724 7.98L8.148 5.952H7.152V9.072H7.8V6.984L8.364 9.072H8.352ZM3.696 6.648V7.2C3.696 7.572 3.9 7.74 4.38 7.74H5.292C5.7 7.74 5.784 7.776 5.784 7.98V8.28C5.784 8.448 5.736 8.46 5.328 8.46H3.732V9.06H5.472C5.892 9.06 6.06 9.036 6.216 8.952C6.396 8.868 6.504 8.64 6.516 8.364V7.692C6.516 7.428 6.456 7.308 6.288 7.2C6.168 7.128 6.096 7.116 5.724 7.116H4.752C4.464 7.116 4.416 7.092 4.416 6.948V6.756C4.416 6.576 4.464 6.54 4.692 6.54H6.372V5.94H4.404C3.912 5.94 3.72 6.144 3.72 6.636L3.696 6.648ZM13.116 11.28L14.556 12.72H16.884L15.444 11.28H13.116ZM21.6 0H2.4C1.08 0 0 1.08 0 2.4V15.6C0 16.92 1.08 18 2.4 18H21.6C22.92 18 24 16.92 24 15.6V2.4C24 1.08 22.92 0 21.6 0ZM2.4 15.6V12.72H13.284L11.844 11.28H2.4V2.4H21.6V11.28H16.716L18.156 12.72H21.6V15.6H2.4Z"
          fill={`${color}`}
        />
      </svg>
    );
  }
);

export const MenuSmartPassIconwithBackgroundColor = React.memo(
  ({ width = 18, height = 18 }: Props) => {
    return (
      <svg
        width={`${width}`}
        height={`${height}`}
        viewBox="0 0 90 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_260_30741)">
          <path
            d="M81.1155 0.546875H8.89327C4.2909 0.546875 0.559937 4.27783 0.559937 8.88021V81.1024C0.559937 85.7048 4.2909 89.4358 8.89327 89.4358H81.1155C85.7179 89.4358 89.4488 85.7048 89.4488 81.1024V8.88021C89.4488 4.27783 85.7179 0.546875 81.1155 0.546875Z"
            fill="url(#paint0_linear_260_30741)"
          />
          <mask
            id="mask0_260_30741"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x="8"
            y="22"
            width="74"
            height="46"
          >
            <path
              d="M75.56 22.2109H14.4489C11.3806 22.2109 8.89331 24.6982 8.89331 27.7665V61.9713C8.89331 65.0395 11.3806 67.5268 14.4489 67.5268H75.56C78.6282 67.5268 81.1155 65.0395 81.1155 61.9713V27.7665C81.1155 24.6982 78.6282 22.2109 75.56 22.2109Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_260_30741)">
            <path
              d="M75.56 22.2109H14.4489C11.3806 22.2109 8.89331 24.6982 8.89331 27.7665V61.9713C8.89331 65.0395 11.3806 67.5268 14.4489 67.5268H75.56C78.6282 67.5268 81.1155 65.0395 81.1155 61.9713V27.7665C81.1155 24.6982 78.6282 22.2109 75.56 22.2109Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M63.735 56.6484H-6.66663V59.9673H65.2478L63.735 56.6484ZM68.1606 59.9673H70.6484L69.1356 56.6484H66.6478L68.1606 59.9673ZM78.2156 59.9673H73.5611L72.0484 56.6484H78.2156V59.9673Z"
              fill="#E61E0A"
            />
            <path
              d="M69.3489 46.4766H67.06V38.0792H63.6328V36.0938H72.7761V38.0792H69.3489V46.4766Z"
              fill="#E6200A"
            />
            <path
              d="M55.0606 42.67V46.4766H52.7084V36.0938H59.2339C61.2073 36.0938 61.7506 36.5364 61.8012 38.0919V40.0269C61.7889 41.0259 61.6245 41.3295 60.815 41.7468C61.485 42.1135 61.7506 42.5815 61.7634 43.4541V46.4766H59.4489V44.7188C59.4617 42.8724 59.3606 42.7206 58.2478 42.67H55.0606ZM57.9945 38.0792H55.0606V40.6592H57.9695C59.2467 40.6465 59.3862 40.558 59.4367 39.736V39.1163C59.4239 38.2184 59.2339 38.0919 57.9945 38.0792Z"
              fill="#E6200A"
            />
            <path
              d="M47.7917 44.0611H44.0609L43.3274 46.4766H40.9246L44.453 36.0938H47.5641L51.0039 46.4766H48.5884L47.7917 44.0611ZM44.6301 42.063H47.2985L45.92 37.8264L44.6301 42.063Z"
              fill="#E6200A"
            />
            <path
              d="M30.8732 39.521V46.4766H28.698V36.0938H32.0367L33.9843 42.8597L35.6663 36.0938H39.2073V46.4766H37.0068V39.3693L35.1478 46.4766H32.7828L30.8732 39.521Z"
              fill="#E6200A"
            />
            <path
              d="M19.5156 36.0938H26.0792V38.0792H20.502C19.718 38.0919 19.5788 38.2057 19.5662 38.8127V39.4704C19.5788 39.951 19.7306 40.0269 20.6917 40.0395H23.9166C25.156 40.0521 25.3836 40.0774 25.801 40.3177C26.3448 40.6592 26.5345 41.0639 26.5471 41.9365V44.1876C26.5345 45.0981 26.1551 45.8443 25.5607 46.1351C25.0422 46.3881 24.4857 46.464 23.1072 46.4766H17.2898V44.4785H22.6267C24.0051 44.4658 24.1569 44.4026 24.1696 43.8587V42.847C24.1569 42.1894 23.8913 42.063 22.5128 42.0503H19.4903C17.9348 42.0376 17.2392 41.4939 17.2266 40.2545V38.4207C17.2645 36.7893 17.9095 36.1317 19.5156 36.0938Z"
              fill="#E6200A"
            />
          </g>
          <path
            d="M75.5556 24.15H14.4445C12.441 24.15 10.8167 25.7742 10.8167 27.7778V61.9826C10.8167 63.9861 12.441 65.6103 14.4445 65.6103H75.5556C77.5592 65.6103 79.1834 63.9861 79.1834 61.9826V27.7778C79.1834 25.7742 77.5592 24.15 75.5556 24.15Z"
            stroke="white"
            strokeWidth="1.7"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_260_30741"
            x="0.359937"
            y="0.446875"
            width="89.2889"
            height="89.2906"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.1" />
            <feGaussianBlur stdDeviation="0.1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.35607 0 0 0 0 0.353103 0 0 0 0 0.501485 0 0 0 0.74 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_260_30741"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_260_30741"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_260_30741"
            x1="0.559937"
            y1="0.546875"
            x2="89.4488"
            y2="89.4358"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EB4C3B" />
            <stop offset="0.498673" stopColor="#EB4C3B" />
            <stop offset="0.499115" stopColor="#E61F0A" />
            <stop offset="1" stopColor="#E61F0A" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
);

export const MenuSmartPassIconInfo = React.memo(
  ({ width = 74, height = 46, color = "white" }: Props) => {
    return (
      <svg
        width={`${width}`}
        height={`${height}`}
        viewBox="0 0 74 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_260_30743"
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={74}
          height={46}
        >
          <path
            d="M67.56 0.210938H6.44887C3.38062 0.210938 0.893311 2.69824 0.893311 5.76649V39.9713C0.893311 43.0395 3.38062 45.5268 6.44887 45.5268H67.56C70.6282 45.5268 73.1155 43.0395 73.1155 39.9713V5.76649C73.1155 2.69824 70.6282 0.210938 67.56 0.210938Z"
            fill={`${color}`}
          />
        </mask>
        <g mask="url(#mask0_260_30743)">
          <path
            d="M67.56 0.210938H6.44887C3.38062 0.210938 0.893311 2.69824 0.893311 5.76649V39.9713C0.893311 43.0395 3.38062 45.5268 6.44887 45.5268H67.56C70.6282 45.5268 73.1155 43.0395 73.1155 39.9713V5.76649C73.1155 2.69824 70.6282 0.210938 67.56 0.210938Z"
            fill={`${color}`}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M55.735 34.6484H-14.6666V37.9673H57.2478L55.735 34.6484ZM60.1606 37.9673H62.6484L61.1356 34.6484H58.6478L60.1606 37.9673ZM70.2156 37.9673H65.5611L64.0484 34.6484H70.2156V37.9673Z"
            fill="#E61E0A"
          />
          <path
            d="M61.3489 24.4766H59.06V16.0792H55.6328V14.0938H64.7761V16.0792H61.3489V24.4766Z"
            fill="#E6200A"
          />
          <path
            d="M47.0606 20.67V24.4766H44.7084V14.0938H51.2339C53.2073 14.0938 53.7506 14.5364 53.8012 16.0919V18.0269C53.7889 19.0259 53.6245 19.3295 52.815 19.7468C53.485 20.1135 53.7506 20.5815 53.7634 21.4541V24.4766H51.4489V22.7188C51.4617 20.8724 51.3606 20.7206 50.2478 20.67H47.0606ZM49.9945 16.0792H47.0606V18.6592H49.9695C51.2467 18.6465 51.3862 18.558 51.4367 17.736V17.1163C51.4239 16.2184 51.2339 16.0919 49.9945 16.0792Z"
            fill="#E6200A"
          />
          <path
            d="M39.7917 22.0611H36.0609L35.3274 24.4766H32.9246L36.453 14.0938H39.5641L43.0039 24.4766H40.5884L39.7917 22.0611ZM36.6301 20.063H39.2985L37.92 15.8264L36.6301 20.063Z"
            fill="#E6200A"
          />
          <path
            d="M22.8732 17.521V24.4766H20.698V14.0938H24.0367L25.9843 20.8597L27.6663 14.0938H31.2073V24.4766H29.0068V17.3693L27.1478 24.4766H24.7828L22.8732 17.521Z"
            fill="#E6200A"
          />
          <path
            d="M11.5156 14.0938H18.0792V16.0792H12.502C11.718 16.0919 11.5788 16.2057 11.5662 16.8127V17.4704C11.5788 17.951 11.7306 18.0269 12.6917 18.0395H15.9166C17.156 18.0521 17.3836 18.0774 17.801 18.3177C18.3448 18.6592 18.5345 19.0639 18.5471 19.9365V22.1876C18.5345 23.0981 18.1551 23.8443 17.5607 24.1351C17.0422 24.3881 16.4857 24.464 15.1072 24.4766H9.28979V22.4785H14.6267C16.0051 22.4658 16.1569 22.4026 16.1696 21.8587V20.847C16.1569 20.1894 15.8913 20.063 14.5128 20.0503H11.4903C9.93479 20.0376 9.23923 19.4939 9.22656 18.2545V16.4207C9.26451 14.7893 9.90945 14.1317 11.5156 14.0938Z"
            fill="#E6200A"
          />
        </g>
      </svg>
    );
  }
);

export const MenuSmartPassCompatibleIcon = React.memo(
  ({ width = 87, height = 34 }: Props) => {
    return (
      <svg
        width={`${width}`}
        height={`${height}`}
        viewBox="0 0 87 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.75"
          y="0.75"
          width="85.5"
          height="32.5"
          rx="4.25"
          fill="white"
        />
        <rect
          x="0.75"
          y="0.75"
          width="85.5"
          height="32.5"
          rx="4.25"
          stroke="#E61E0A"
          stroke-width="0.5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.6324 17.394C21.5218 17.394 20.4112 16.9847 19.5658 16.1662C17.875 14.5291 17.875 11.8649 19.5658 10.2278C21.2566 8.59073 24.0083 8.59073 25.6991 10.2278L26.3224 10.8313L21.5474 15.4558C22.4992 15.8833 23.6677 15.7178 24.4525 14.9592C24.6962 14.7233 24.886 14.4483 25.0152 14.142L26.6482 14.7884C26.4301 15.3059 26.111 15.7686 25.7004 16.1662C24.855 16.9847 23.7444 17.394 22.6338 17.394H22.6324ZM22.6324 10.7075C21.9728 10.7075 21.3145 10.9499 20.8137 11.4361C20.0289 12.1959 19.8579 13.3273 20.3008 14.2488L23.7188 10.9395C23.3755 10.7857 23.004 10.7088 22.6338 10.7088L22.6324 10.7075ZM13.6082 9C12.8237 9 12.1104 9.30112 11.5878 9.78755C11.0652 9.30112 10.3519 9 9.56733 9C7.96734 9 6.66694 10.2469 6.66694 11.7783V17.1045H8.42678V11.7783C8.42678 11.176 8.9386 10.6858 9.56733 10.6858C10.196 10.6858 10.7079 11.176 10.7079 11.7783V17.1045H12.4677V11.7783C12.4677 11.176 12.9795 10.6858 13.6082 10.6858C14.237 10.6858 14.7488 11.176 14.7488 11.7783V17.1045H16.5086V11.7783C16.5086 10.2457 15.2069 9 13.6082 9ZM34.6891 17.1045H36.4901V12.9044C36.4901 10.7523 34.6162 9 32.3146 9C30.0133 9 28.1395 10.751 28.1395 12.9044V17.1045H29.9404V12.9044C29.9404 11.6805 31.0059 10.6842 32.3146 10.6842C33.6235 10.6842 34.6891 11.6805 34.6891 12.9044V17.1045ZM42.157 17.394C39.8543 17.394 37.9818 15.6417 37.9818 13.4896V9.28946H39.7828V13.4896C39.7828 14.7135 40.8483 15.7098 42.157 15.7098C43.4659 15.7098 44.5314 14.7135 44.5314 13.4896V9.28946H46.3324V13.4896C46.3324 15.643 44.4586 17.394 42.157 17.394ZM32.5615 23.5701L32.5606 23.5703L32.5617 23.5692L32.5615 23.5701ZM32.5615 23.5701C33.1743 23.4043 33.4246 23.1009 33.7436 22.1255L34.8389 18.9187H36.1805L34.9833 22.327C34.6071 23.4176 34.3482 23.8508 33.8136 24.3133C33.3446 24.6956 32.823 24.9198 32.3159 24.949L32.5615 23.5701ZM38.4217 18.9046H37.3863L37.3852 18.9057C37.5776 20.6104 37.6269 22.2999 37.5382 24.8851H38.9311C38.9661 22.9714 38.9267 21.4692 38.8129 20.306C38.3188 20.0537 38.1734 19.8078 38.2555 19.3454C38.2817 19.2003 38.3198 19.1071 38.4217 18.9046ZM39.481 18.4421C38.9923 18.4421 38.5298 18.8255 38.4469 19.2945H38.4479C38.3616 19.7786 38.695 20.1609 39.1684 20.1609C39.6417 20.1609 40.1053 19.7721 40.1882 19.3021C40.2715 18.832 39.9697 18.4421 39.481 18.4421ZM39.3739 18.9631C39.5629 18.9631 39.6897 19.1147 39.656 19.3021C39.622 19.4894 39.4341 19.641 39.2526 19.641C39.0711 19.641 38.9464 19.4819 38.9781 19.3021C39.0097 19.1223 39.1847 18.9631 39.3739 18.9631ZM27.8811 18.6025H29.2149L28.8716 20.5303C30.4984 20.9343 31.0866 21.1076 32.0935 21.4758L31.8551 22.8122C30.9412 22.4581 30.0699 22.1906 28.6399 21.8299L28.0757 25H26.742L27.8811 18.6025ZM6.366 23.7588H6.82516C7.93154 23.7664 8.54923 23.4913 9.23142 22.6898C9.67748 22.1916 10.4438 21.0361 10.985 20.0461H7.52922L7.74131 18.8548H13.0119C12.3942 20.1111 11.9197 20.9342 11.3064 21.8018C11.9165 22.9216 12.2915 23.8021 12.6358 24.9003H11.0539C10.868 24.1422 10.7183 23.7155 10.41 23.0299C9.49598 24.2722 8.42351 24.8927 7.06677 24.9794H6.14844L6.366 23.7588ZM14.2908 21.3825H15.7339L15.9853 21.9749L16.1832 22.4591C17.9838 22.2934 18.6496 21.8309 18.8967 20.567L18.9754 20.1262H14.0185L14.2241 18.9706H20.4567L20.1791 20.5302C19.8412 22.3865 18.8715 23.2096 16.661 23.5421C16.8107 23.9677 16.8993 24.2493 17.0873 24.871H15.6584C15.2933 23.7295 14.8429 22.6107 14.2886 21.3825H14.2908ZM26.2426 21.1877H21.0486L20.8299 22.4159H26.024L26.2426 21.1877ZM40.2046 23.7588H40.6637C41.7699 23.7664 42.3877 23.4913 43.0698 22.6898C43.5159 22.1916 44.2823 21.0361 44.8236 20.0461H41.3678L41.5799 18.8548H46.8504C46.2326 20.1111 45.7582 20.9342 45.1448 21.8018C45.7548 22.9216 46.1299 23.8021 46.4742 24.9003H44.8923C44.7064 24.1422 44.5568 23.7155 44.2483 23.0299C43.3345 24.2722 42.262 24.8927 40.9053 24.9794H39.9868L40.2046 23.7588Z"
          fill="#E61E0A"
        />
        <path
          d="M53.7416 14.89H58.4716V15.8H53.7416V14.89ZM49.3616 14.17H54.0616V15.05H49.3616V14.17ZM56.3916 12.56H57.3316V20.62C57.3316 21.2 57.2016 21.48 56.8616 21.64C56.5316 21.81 55.9816 21.84 55.1316 21.84C55.1016 21.57 54.9616 21.12 54.8316 20.83C55.4316 20.86 55.9816 20.85 56.1516 20.85C56.3216 20.84 56.3916 20.79 56.3916 20.62V12.56ZM53.7616 17.1L54.5316 16.74C55.0116 17.41 55.4916 18.31 55.6516 18.92L54.8216 19.33C54.6716 18.73 54.2316 17.8 53.7616 17.1ZM49.6216 16.47L50.2916 15.93C51.5016 17.21 52.9016 18.95 53.4816 20.11L52.7316 20.76C52.1816 19.57 50.8116 17.77 49.6216 16.47ZM51.2016 12.57H52.1116V14.7H51.2016V12.57ZM52.3216 15.27L53.2416 15.4C52.7316 18.36 51.7216 20.46 49.7516 21.77C49.6416 21.58 49.3016 21.2 49.1016 21.03C50.9816 19.92 51.9016 17.95 52.3216 15.27ZM63.0916 16.68H64.0216V20.39C64.0216 20.75 64.0916 20.8 64.4316 20.8C64.5916 20.8 65.3316 20.8 65.5316 20.8C65.8916 20.8 65.9516 20.55 65.9916 19.12C66.1916 19.28 66.5816 19.44 66.8316 19.51C66.7416 21.19 66.5016 21.66 65.6116 21.66C65.4216 21.66 64.4916 21.66 64.3016 21.66C63.3416 21.66 63.0916 21.36 63.0916 20.39V16.68ZM61.7016 17.5L62.5516 17.69C62.4316 18.81 62.2116 20.13 61.7216 20.93L60.8816 20.55C61.3416 19.78 61.5916 18.58 61.7016 17.5ZM63.2116 15.52L63.8516 14.9C64.6516 15.29 65.7016 15.91 66.2316 16.37L65.5516 17.08C65.0616 16.61 64.0316 15.95 63.2116 15.52ZM66.3416 17.59L67.1816 17.26C67.8216 18.29 68.4316 19.64 68.6016 20.54L67.6716 20.93C67.5316 20.03 66.9616 18.65 66.3416 17.59ZM63.6616 12.56H64.6416V14.32H63.6616V12.56ZM60.4616 13.81H68.3816V14.71H60.4616V13.81ZM60.0116 13.81H60.9516V16.37C60.9516 17.94 60.8116 20.3 59.9316 21.84C59.7616 21.68 59.3416 21.41 59.1116 21.31C59.9416 19.87 60.0116 17.81 60.0116 16.37V13.81Z"
          fill="#E61E0A"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M76.6088 17.0034L73.3008 20.3114L74.1847 21.1953L78.3766 17.0034L74.1847 12.8114L73.3008 13.6953L76.6088 17.0034Z"
          fill="#E61E0A"
        />
      </svg>
    );
  }
);
